import React from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { motion } from 'framer-motion';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../../../theme';

type ElevateScrollProps = {
  threshold?: number;
  children?: React.ReactNode;
};

const ElevationScroll: React.FC<ElevateScrollProps> = ({
  children,
  threshold = 0,
}) => {
  const trigger = useScrollTrigger({ threshold });
  const isMobile = useMediaQuery(
    `(max-width: ${theme.breakpoints.values.md}px)`,
  );

  const variants = {
    visible: {
      top: isMobile ? 70 : 68,
    },
    hidden: {
      top: 0,
    },
  };

  return (
    <motion.div
      initial="visible"
      variants={variants}
      animate={trigger ? 'hidden' : 'visible'}
      transition={{
        type: 'linear',
        duration: 0.2,
      }}
      style={{
        position: 'sticky',
        zIndex: 10,
      }}
    >
      {children}
    </motion.div>
  );
};

export default ElevationScroll;
